import { render, staticRenderFns } from "./Lotes.vue?vue&type=template&id=3a91247a"
import script from "./Lotes.vue?vue&type=script&lang=js"
export * from "./Lotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports